import { Locale } from 'components/core/locale/types';

export const MessagingTranslations = {
  [Locale.English]: {
    MessagingTranslations: {},
  },
};
